<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/plugins/weather-icons']" appearance="plain" variant="neutral">&larr; Back to Weather Icons</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>WeatherIconsPageConfigurator</h1>
			<a href="javascript:void(0)" onclick="document.getElementById('examples-section')?.scrollIntoView({behavior:'smooth'})" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-s);white-space:nowrap;">Examples ↓</a>
		</div>
		<p waBody="m" waColorText="quiet" waText>Page configurator that auto-registers the weather-icons.min.css stylesheet. Implements IPageConfigurator.</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_1164" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</wa-details>
		<wa-details open summary="Properties (1)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">enabled</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">boolean</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">true</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Whether the Weather Icons configurator is active</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
		<wa-details open summary="Methods (5)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Signature</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">Page&lt;?&gt; page</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Registers the Weather Icons CSS reference on the page</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);"></td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Returns whether the configurator is enabled</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">boolean mustEnable</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Globally enable or disable Weather Icons registration</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);"></td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Returns the CSS reference object</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);"></td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Returns current enabled state</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
		<div class="wa-stack wa-gap-m" id="examples-section">
			<h2 waHeading="l" waText>Examples</h2>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Module requirement</h4>
				<p waBody="s" waColorText="quiet" waText>Add to your module-info.java.</p>
				<markdown [data]="mdContent_1165" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</div>
	</div>
</div>